module.exports = __webpack_public_path__ + "static/media/ic_proyectos_communication_pin_seleccionado.34f80ca0.svg";